/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation200,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation400,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation401,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation500,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiationMutationResponse,
  PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiationPathParams,
} from "../../types/individualPaymentRenegotiationController/PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation.ts";

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiationPathParamsSchema =
  z.object({
    financialPersonId: z.coerce.number().int(),
  }) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiationPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation200Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation200>;

/**
 * @description Renegociação inexistente ou já ativa
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation400Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation401Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation500Schema =
  z.any() as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation500>;

export const postApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiationMutationResponseSchema =
  z.lazy(
    () =>
      postApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiation200Schema,
  ) as unknown as ToZod<PostApiV1IndividualpaymentFinancialPeopleFinancialpersonidAcceptRenegotiationMutationResponse>;
